import { useEffect, useState } from 'react';
import { useAuth } from '../lib/auth-context';
import { useEnterpriseOrg } from '../context/EnterpriseOrgContext';
import {
  fetchEnterpriseWorkspaceRenewalPreview,
  type EnterpriseRenewalExpansionWorkspacePreview,
} from '../lib/enterprise-api';

export function useEnterpriseWorkspaceRenewalPreview() {
  const { accessToken } = useAuth();
  const { activeOrgId, hasActiveOrgAccess } = useEnterpriseOrg();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [preview, setPreview] = useState<EnterpriseRenewalExpansionWorkspacePreview | null>(null);

  useEffect(() => {
    let cancelled = false;
    if (!accessToken || !activeOrgId || !hasActiveOrgAccess) {
      setPreview(null);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    void fetchEnterpriseWorkspaceRenewalPreview(accessToken, activeOrgId).then((res) => {
      if (cancelled) return;
      if (!res.success || !res.preview) {
        setPreview(null);
        setError(res.error || 'Renewal preview unavailable');
        setLoading(false);
        return;
      }
      setPreview(res.preview);
      setError(null);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [accessToken, activeOrgId, hasActiveOrgAccess]);

  return { loading, error, preview };
}
